/* eslint-disable */
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '2rem' }}>
    <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--brand-green)', marginBottom: '0.75rem', paddingBottom: '0.5rem', borderBottom: '2px solid var(--border)' }}>{title}</h2>
    {children}
  </div>
);

const P = ({ children }) => <p style={{ marginBottom: '0.75rem', lineHeight: 1.7 }}>{children}</p>;
const Sub = ({ title, children }) => (
  <div style={{ marginBottom: '1rem', marginLeft: '1rem' }}>
    <h3 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '0.5rem' }}>{title}</h3>
    {children}
  </div>
);
const Ul = ({ items }) => (
  <ul style={{ marginBottom: '0.75rem', paddingLeft: '1.5rem', lineHeight: 1.7 }}>
    {items.map((item, i) => <li key={i} style={{ marginBottom: '0.25rem' }}>{item}</li>)}
  </ul>
);

export default function EULA() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <div style={{ background: '#1a3c34', padding: '1.5rem 2rem' }}>
        <div style={{ maxWidth: '860px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <img src="/casavello-stacked-inverted.png" alt="casavello" style={{ height: '40px', objectFit: 'contain' }} />
          <button onClick={() => navigate('/login')} style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', padding: '0.5rem 1rem', borderRadius: '0.375rem', cursor: 'pointer', fontSize: '0.875rem' }}>← Back to Login</button>
        </div>
      </div>

      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <div style={{ background: '#fff', borderRadius: '0.75rem', padding: '2.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
          <h1 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: '0.5rem' }}>End User Licence Agreement</h1>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '0.25rem' }}>Hibernian Technologies Limited, trading as casavello | Version 1.5 | October 2026</p>

          <Section title="1. Licence Grant">
            <P>Subject to your compliance with this EULA and payment of applicable fees, Hibernian Technologies Limited, trading as casavello ("casavello", "we", "us", "our"), grants you a limited, non-exclusive, non-transferable, revocable licence to access and use the casavello software platform for your internal property management purposes.</P>
          </Section>

          <Section title="2. Permitted Use">
            <Ul items={['Manage properties, rooms and tenancies', 'Record rental payments and expenses', 'Use optional AI-assisted features to speed up manual data entry (e.g. scanning receipts, rent statements and compliance certificates), always reviewing and confirming results before they are saved', 'Generate financial and tax reports for internal use', 'Manage maintenance requests and contractors', 'Track property compliance obligations', 'Invite colleagues within your organisation']} />
          </Section>

          <Section title="3. Restrictions">
            <P>You may not:</P>
            <Ul items={[
              'Copy, modify, adapt or create derivative works of the Software',
              'Reverse engineer or decompile any part of the Software',
              'Remove or alter any proprietary notices or marks',
              'Use the Software to provide bureau or outsourcing services to third parties',
              'Transfer, sublicence, rent or lend your access to any third party',
              'Attempt to circumvent any technical protection measures',
              'Access the Software by means other than casavello\'s provided interfaces'
            ]} />
          </Section>

          <Section title="4. Intellectual Property">
            <P>The Software and all intellectual property rights therein remain the exclusive property of casavello. This EULA transfers no ownership rights. The casavello name and logo are trademarks of Hibernian Technologies Limited.</P>
            <Sub title="4.1 Feedback and Suggestions">
              <P>Any feedback, suggestions, ideas, feature requests or other input you provide regarding the Software ("Feedback") is owned exclusively by casavello immediately upon submission. You irrevocably assign all rights in Feedback to casavello. casavello may use, modify or commercialise Feedback at its sole discretion with no obligation, compensation or attribution to you. This applies regardless of the form or channel of Feedback including emails, support tickets, conversations or social media.</P>
            </Sub>
          </Section>

          <Section title="5. Tax and Financial Disclaimer">
            <P>The Software generates financial reports as an organisational tool only. These outputs:</P>
            <Ul items={[
              'Do not constitute tax advice, financial advice or legal advice',
              'Are not a substitute for advice from a qualified accountant or tax adviser',
              'May not reflect all applicable tax rules relevant to your circumstances',
              'Should not be relied upon for submitting tax returns without professional verification'
            ]} />
            <P><strong>casavello expressly disclaims all liability for any tax liability, penalty, interest, fine or other loss arising from reliance on Software-generated reports.</strong></P>
          </Section>

          <Section title="5A. AI-Assisted Features">
            <P>The Software may offer optional AI-assisted features, including scanning of receipts, rent statements and compliance certificates, and generation of portfolio summaries. In connection with these features:</P>
            <Ul items={[
              'Use of AI-assisted features is entirely optional; manual entry is always available as an alternative',
              'AI-generated results are not saved automatically and must be reviewed and confirmed by you before they are saved',
              'casavello makes no representation or warranty, express or implied, that any AI-generated output is accurate, complete or reliable',
              'You are solely responsible for verifying AI-extracted data before relying on it for any purpose, including accounting, tax or compliance purposes'
            ]} />
          </Section>

          <Section title="6. No Warranty">
            <P>THE SOFTWARE IS PROVIDED "AS IS". TO THE MAXIMUM EXTENT PERMITTED BY THE LAW OF ENGLAND AND WALES, CASAVELLO DISCLAIMS ALL WARRANTIES INCLUDING WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. CASAVELLO DOES NOT WARRANT THAT THE SOFTWARE WILL BE UNINTERRUPTED, ERROR-FREE OR THAT REPORTS WILL BE ACCURATE.</P>
          </Section>

          <Section title="7. Limitation of Liability">
            <P>TO THE MAXIMUM EXTENT PERMITTED BY LAW, CASAVELLO'S TOTAL LIABILITY SHALL NOT EXCEED FEES PAID IN THE 12 MONTHS PRECEDING THE CLAIM. CASAVELLO IS NOT LIABLE FOR INDIRECT, CONSEQUENTIAL OR PUNITIVE DAMAGES, OR FOR LOSSES ARISING FROM RELIANCE ON PLATFORM-GENERATED REPORTS.</P>
          </Section>

          <Section title="8. Term and Termination">
            <P>This EULA is effective from first access and continues until terminated. casavello may terminate immediately on breach. Upon termination your licence ceases immediately. Clauses 4, 5, 6 and 7 survive termination.</P>
          </Section>

          <Section title="9. Governing Law">
            <P>This EULA is governed by the laws of England and Wales. Disputes are subject to the exclusive jurisdiction of the courts of England and Wales.</P>
          </Section>

          <Section title="10. Contact">
            <P>Hibernian Technologies Limited | Company registration number: 17444267 | Registered office: 71-75 Shelton Street, Covent Garden, London, WC2H 9JQ | <a href="mailto:info@casavello.io" style={{ color: 'var(--brand-green)' }}>info@casavello.io</a> | <a href="https://www.casavello.io" style={{ color: 'var(--brand-green)' }}>www.casavello.io</a></P>
          </Section>
        </div>

        <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
          casavello by Hibernian Technologies Limited | <a href="https://www.casavello.io/privacy" style={{ color: 'var(--brand-green)' }}>Privacy Policy</a> | <a href="https://www.casavello.io/terms" style={{ color: 'var(--brand-green)' }}>Terms of Service</a>
        </div>
      </div>
    </div>
  );
}
